import { useSyncExternalStore } from 'react'

/**
 * Open/closed state of the homepage advanced-search panel (mock `#hsearch`).
 * Written by the nav search input (focus opens it), read by the Home page which renders
 * the panel under the filter bar. A module store keeps Navbar and Home decoupled.
 */
let isOpen = false
const listeners = new Set()

const emit = () => listeners.forEach((listener) => listener())

export const openAdvancedSearch = () => {
    if (isOpen) return
    isOpen = true
    emit()
}

export const closeAdvancedSearch = () => {
    if (!isOpen) return
    isOpen = false
    emit()
}

const subscribe = (listener) => {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

const getSnapshot = () => isOpen

export const useAdvancedSearchOpen = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
